export const getTelegramWebApp = () => {
  try {
    return window.Telegram?.WebApp || null;
  } catch {
    return null;
  }
};

export const getTelegramInitData = () => {
  try {
    return getTelegramWebApp()?.initData || "";
  } catch {
    return "";
  }
};

export const getTelegramStartParam = () => {
  try {
    return getTelegramWebApp()?.initDataUnsafe?.start_param || "";
  } catch {
    return "";
  }
};

export const initializeTelegramWebApp = () => {
  const tg = getTelegramWebApp();
  if (!tg) return false;

  try {
    tg.ready?.();
  } catch (error) {
    console.warn("Telegram WebApp ready() failed", error);
  }
  try {
    tg.expand?.();
  } catch (error) {
    console.warn("Telegram WebApp expand() failed", error);
  }
  return true;
};

export const safeSessionStorage = {
  get(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
      return true;
    } catch {
      return false;
    }
  },
};

export const safeLocalStorage = {
  get(key) {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch {
      return false;
    }
  },
  remove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch {
      /* Storage can be disabled in embedded browsers. */
    }
  },
};
